// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__2Go8z","container":"style_container__N0gW1","field":"style_field__Oduoy","checkbox":"style_checkbox__2CocN","buttons":"style_buttons__10hNd"};